import { useEffect, useState } from "react";

/**
 * Track a media query as React state.
 *
 * Layout trees branch on this rather than toggling CSS visibility, so a pane
 * that fetches, polls or holds a live channel subscription is never mounted
 * twice at once. Mirrors `useIsMobile`, which is the fixed-breakpoint case of
 * the same idea.
 *
 * @param {string} query - A media query, e.g. `(min-width: 1280px)`.
 * @returns {boolean}
 */
export function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const mql = window.matchMedia(query);
    // Re-read on subscribe: the query may have changed between render and
    // effect, and the listener only fires on the *next* transition.
    setMatches(mql.matches);
    const handleChange = (e) => setMatches(e.matches);
    mql.addEventListener("change", handleChange);
    return () => mql.removeEventListener("change", handleChange);
  }, [query]);

  return matches;
}

export default useMediaQuery;
